import constant from "../constant";
const initialState = {
  loaded: false,
  loading: false,
  data: {}
};

const profile = (state = initialState, action) => {
  switch (action.type) {
    case constant.PROFILE_LOADING:
      return { ...state, loading: true };
    case constant.ADD_PROFILE:
      return { loaded: true, loading: false, data: action.payload };
    case constant.UPDATE_PLUGIN:
      let updatedPlugins = { ...state?.data?.setting?.plugins, ...action.payload };
      return { ...state, data: { ...state.data, setting: { ...state.data.setting, plugins: updatedPlugins } } };
    case constant.UPDATE_SLIDER_LIST:
      // let list = state.data?.landingPage?.sliders || [];
      // list = list.map(item => item._id === action.payload._id ? action.payload : item);
      return { ...state, data: { ...state.data, landingPage: { sliders: action.payload } } };
    default:
      return state;
  }
}



export default profile;